import { CButton, CCol, CLabel, CRow } from "@coreui/react";
import React from "react";

const LotListViewBidderRefundInstallmentAdjustment = (props) => {
  return (
    <>
      <CRow className="pt-2  mt-2">
        <CCol className="mb-2" xl={12}>
          <strong>Refund Installment Adjustment Amount </strong>
          <hr />
        </CCol>
      </CRow>
      <CRow className="pr-1">
        <CCol xl={9}>
          <CLabel>{props.viewListDetails.refundAdjustmentNotes}</CLabel>
        </CCol>
        <CCol xl={3}>
          {props.viewListDetails.refundAdjustmentApprovedByDFO === true && (
            <CButton
              color="info"
              className=" ml-2 mr-2"
              //   hidden={
              //     props.viewListDetails.refundAdjustmentApprovedByDFO === true
              //       ? false
              //       : true
              //   }
              onClick={() => {
                props.ShowRefundHistory(
                  props.viewListDetails.tenderId,
                  props.viewListDetails.lotNo,
                  7
                );
              }}
            >
              View Refund Status
            </CButton>
          )}
        </CCol>
      </CRow>
    </>
  );
};

export default LotListViewBidderRefundInstallmentAdjustment;
